import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Layout.css';

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowUserMenu(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials = user
    ? `${user.firstName?.[0] || ''}${user.lastName?.[0] || ''}`.toUpperCase() ||
      user.name?.[0]?.toUpperCase() || 'U'
    : 'U';

  const navLinks = [
    { path: '/', label: 'Dashboard' },
    { path: '/contacts', label: 'Contacts' },
    { path: '/campaigns', label: 'Campaigns' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div className="layout">
      {/* KNKT Background */}
      <div className="knkt-bg">
        <div className="knkt-bg__base" />
        <div className="knkt-bg__orb knkt-bg__orb--1" />
        <div className="knkt-bg__orb knkt-bg__orb--2" />
        <div className="knkt-bg__orb knkt-bg__orb--3" />
        <div className="knkt-bg__orb knkt-bg__orb--4" />
        <div className="knkt-bg__orb knkt-bg__orb--5" />
        <div className="knkt-bg__noise" />
        <div className="knkt-bg__grid" />
      </div>

      {/* Top Nav */}
      <header className="layout-nav">
        <div className="layout-nav-inner">
          {/* Logo */}
          <Link to="/" className="layout-logo">
            <span className="layout-logo-knkt">KNKT</span>
            <span className="layout-logo-sep">•</span>
            <span className="layout-logo-sub">CRM</span>
          </Link>

          {/* Nav Links */}
          <nav className="layout-nav-links">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`layout-nav-link ${isActive(link.path) ? 'active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* User */}
          <div className="layout-user" ref={menuRef}>
            <button
              className="layout-user-btn"
              onClick={e => { e.stopPropagation(); setShowUserMenu(v => !v); }}
            >
              {user?.profileImage
                ? <img src={user.profileImage} alt={user.name} className="user-avatar-img" />
                : <div className="user-avatar-initials">{initials}</div>}
            </button>
            {showUserMenu && (
              <div className="user-menu">
                <div className="user-menu-name">{user?.name || user?.firstName}</div>
                <div className="user-menu-email">{user?.email}</div>
                <hr className="user-menu-divider" />
                <button className="user-menu-logout" onClick={handleLogout}>Sign Out</button>
              </div>
            )}
          </div>
        </div>
      </header>

      <main className="layout-main">{children}</main>
    </div>
  );
}
